export default "__VITE_ASSET__e0b273d1__"